import RestaurantSelectModal from "./modals/RestaurantSelectModal";
import RestaurantSaga from "./saga";

import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import RestaurantsTableReducer from "./reducers/RestaurantsTableReducer";

export const moduleName = "Booking.restaurants";
export const url = "restaurants";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["booking.restaurants.read"]) {
        config.active = true;

        registerModals({
            RestaurantSelectModal,
        });
        store.injectSaga?.("RestauarntSaga", RestaurantSaga);
        store.reducerManager?.add(
            "BookingRestaurantTable",
            RestaurantsTableReducer
        );

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Booking/Restaurant/pages/RestaurantIndexPage" />
            ),
        });
    }

    if (permissions["booking.payment.system.create"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="Booking/Restaurant/pages/RestaurantEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
